export const GUEST = "guest";

export const STATUS_REGISTERED = "Registered";
export const STATUS_INVITED = "Invited";
export const STATUS_UNINVITED = "Uninvited";
export const STATUS_CHECKED_IN = "Checked in";


export const ORDER_ASC = 'ASC';
export const ORDER_DESC = 'DESC';

export const FORMAT_XSLX = 'xlsx'
export const FORMAT_CSV = 'xls'

const adminApi = (path: string) => `admin/${path}`;

export const MAGMA_API_BASE = adminApi('collections/promo-2026/');

export const API_CUSTOMERS = 'customers';
export const API_CUSTOMERS_EXPORT = `${API_CUSTOMERS}/export`;
export const API_CHECK_COUPON = 'check-coupon';
export const API_COUPONS = 'coupons';
export const API_COUPONS_EXPORT = `${API_COUPONS}/export`;

export const API_ADMIN_PRODUCTS = adminApi('products');
export const API_ADMIN_COLLECTIONS = adminApi('collections');
export const API_ADMIN_ROLES = adminApi('roles');
export const API_ADMIN_SUBSCRIPTIONS_IMPORT_CSV = adminApi('subscriptions/import-csv');
export const API_ADMIN_USERS = adminApi('users');
export const API_UPDATE_PASSWORD = 'update-password';

export const API_ADMIN_EVENTS = adminApi('events');
export const API_ADMIN_EVENTS_GET_TYPES = `${API_ADMIN_EVENTS}/get-types`;
export const API_ADMIN_PARTICIPANTS_GET_STATUSES = adminApi('participants/get-statuses');
export const API_ADMIN_PARTICIPANTS_GET_TYPES = adminApi('participants/get-types');
export const API_ADMIN_STORES = adminApi('stores');

export const API_LOGIN = 'login';
export const API_PROFILE = 'profile';
export const API_FORGOT_PASSWORD = 'forgot-password';
export const API_LOGOUT = 'logout';